import { Box, BoxProps } from '@mui/material';
import { PropsWithChildren } from 'react';

interface CenteredMuiProps extends BoxProps {
  readonly minHeight?: BoxProps['minHeight'];
}

/**
 * A MUI-based centered container component that centers its children
 * both horizontally and vertically using flexbox.
 */
export const CenteredMui = (props: PropsWithChildren<CenteredMuiProps>) => {
  const { minHeight = '250px', children, sx, ...rest } = props;

  return (
    <Box
      {...rest}
      sx={{
        height: '100%',
        minHeight,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        textAlign: 'center',
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};
